export const featureCards = [
  {
    title: "Find Viral Clips",
    subtitle: "Analyze uploaded videos and identify promising moments to turn into clips.",
  },
  {
    title: "Cam Combiner",
    subtitle: "Combine multi-camera recordings with guided and automatic speaker cuts.",
  },
  {
    title: "Idea-to-Video",
    subtitle: "Draft scenes, voiceover, visuals, and captions, then render a video using credits.",
  },
  {
    title: "Smart Promo",
    subtitle: "Create promotional clip plans, captions, hooks, and copy for eligible videos.",
  },
  {
    title: "Cross-Platform Publishing",
    subtitle: "Upload once and publish to supported connected platforms.",
  },
];

export const workflowSteps = [
  {
    title: "Upload",
    text: "Drop long-form content and source metadata once.",
  },
  {
    title: "Edit & Enhance",
    text: "Trim, format, and prepare media with the editing tools available on your plan.",
  },
  {
    title: "Publish",
    text: "Publish now or queue content for supported connected platforms.",
  },
  {
    title: "Track Results",
    text: "Track views, clicks, CTR, and available platform breakdowns.",
  },
  {
    title: "Learn & Improve",
    text: "Compare results and optionally rotate an alternate title or hook.",
  },
];

export const proofChecklist = [
  {
    label: "Optional clip analysis",
    text: "Run Find Viral Clips on a video when you want suggested moments; analysis uses credits.",
  },
  {
    label: "Caption workflow",
    text: "Generate caption drafts where available, then review and edit them before publishing.",
  },
  {
    label: "Platform copy",
    text: "Customize titles, descriptions, captions, and other supported settings per destination.",
  },
];

export const exampleContent = [
  {
    tag: "Video to suggested moments",
    text: "Analyze an eligible uploaded video and choose the moments you want to use.",
  },
  {
    tag: "Idea to video",
    text: "Draft scenes and captions, review them, and spend credits only when you render.",
  },
  {
    tag: "Platform publishing",
    text: "Use one source asset with destination-specific copy and publishing settings.",
  },
];

export const pricingCards = [
  {
    name: "Starter",
    subtitle: "Try the core workflow",
    price: "$0",
    note: "Forever",
    cta: "Start Free",
    bullets: [
      "15 monthly credits",
      "3 uploads per month",
      "1 connected platform",
      "1 workspace seat",
      "Basic analytics",
    ],
  },
  {
    name: "Creator",
    subtitle: "For consistent publishing",
    price: "$14.99",
    note: "per month",
    cta: "Choose Creator",
    bullets: [
      "150 monthly credits",
      "20 uploads per month",
      "5 connected platforms",
      "1 workspace seat",
      "Email support",
    ],
    featured: true,
  },
  {
    name: "Studio",
    subtitle: "For higher-volume creators",
    price: "$34.99",
    note: "per month",
    cta: "Choose Studio",
    bullets: [
      "500 monthly credits",
      "80 uploads per month",
      "6 connected platforms",
      "3 team seats",
      "Recovery Lab access",
    ],
  },
  {
    name: "Agency",
    subtitle: "For larger publishing operations",
    price: "$99.99",
    note: "per month",
    cta: "Choose Agency",
    bullets: [
      "2,000 monthly credits",
      "240 uploads per month",
      "6 connected platforms",
      "10 team seats",
      "Export-ready analytics",
    ],
  },
];
